<template>
    <div class="navbar-collapse collapse order-1 order-md-0 dual-collapse2" 
        :class="[classes]" 
        :id="id" 
        v-if="position==null||position==='left'||showComponent"
        :key="componentRefresh"
    >
        <template v-if="content">
            <slot></slot>
        </template>
        <template v-else>
            <ul class="navbar-nav mr-auto">
                <slot></slot>
            </ul>
        </template>
    </div>
    <div class="navbar-collapse collapse mx-auto order-0" :class="[classes]" :id="id" v-else-if="position==='center'">
        <template v-if="content">
            <slot></slot>
        </template>
        <template v-else>
            <ul class="navbar-nav ml-auto">
                <slot></slot>
            </ul>
        </template>
    </div>
    <div class="navbar-collapse collapse order-3 dual-collapse2" :class="[classes]" :id="id" v-else>
        <template v-if="content">
            <slot></slot>
        </template>
        <template v-else>
            <ul class="navbar-nav ml-auto">
                <slot></slot>
            </ul>
        </template>
    </div> 
</template>


<script>
import checkPermissions from '../../mixins/checkPermissions'; 
export default {
    /**
        tag
        name: ks-menu-group
        description: menu group
    **/
    name:"menu-group",
    mixins: [checkPermissions],
    props:{
        /**
            attribute
            name: id 
            description: id
        **/
        id:{
            type:String,
            default: null
        },
        /**
            attribute
            name: classes 
            description: classes
        **/
        classes:{
            type:String,
            default: null
        },
        /**
            attribute
            name: position 
            description: position
        **/
        position: {
            type: String,
            default:null
        },
        /**
            attribute
            name: content 
            description: content
        **/
        content: {
            type: Boolean,
            default: false
        }   
    }
}
</script>